<template>
  <div>
    <div class="treat-modal">
      <a-modal
        :centered="true"
        v-model="showModal"
        footer
        @ok="hide"
        wrapClassName="add-edit-modal"
        class="treatment-modal onboarding-modal"
        :dialog-style="{ margin: '0px' }"
        width="587px"
        :closable="false"
      >
        <template #title>
          <div class="d-flex align-items-center">
            <font-awesome-icon :icon="['fal', 'times']" class="show-in-mobile font-black mr-3 font20" @click="hide" />
            <h5 class="fw700 font20 gray700 mb-0">{{ editTreatment ? "Edit Medication" : "Add Medication" }}</h5>
            <a-button
              class="dovemed-button primary-button font-white rounded show-in-mobile ml-auto"
              :style="{
                background: getPrimaryColor(),
                opacity: !treatmentData.start_date || !treatmentData.treatment || (!treatmentData.end_date && !treatmentData.currentlyInTreatment) ? '0.3' : '1',
              }"
              @click="treatmentForm"
              :disabled="!treatmentData.start_date || !treatmentData.treatment || (!treatmentData.end_date && !treatmentData.currentlyInTreatment)"
            >
              {{ saving ? "Saving..." : "Save" }}
            </a-button>
            <font-awesome-icon :icon="['fal', 'times']" class="hide-in-mobile font-black ml-auto font20 cp" @click="hide" />
          </div>
        </template>
        <div class="terms-modal-container text-center">
          <div class="context">
            <form>
              <div class="row">
                <div class="text-left col-sm-12 position-relative">
                  <label for="treatment_type" class="mb-1 input-label"> Name of Medication </label>
                  <font-awesome-icon size="1x" :icon="['fal', 'search']" class="position-absolute search-icon gray400" />
                  <span class="required">*</span>
                  <a-select
                    :allowClear="true"
                    showSearch
                    :size="'large'"
                    v-model="treatmentData.treatment"
                    class="w-100 selectMain addMedicationSelect onboarding-modal-selects"
                    placeholder="Search Medication"
                    :showArrow="false"
                    :filterOption="false"
                    @search="handleTreatmentSearch"
                    @change="handleTreatmentChange"
                    notFoundContent=""
                    :loading="loadingMed"
                  >
                    <a-select-option v-if="loadingMed" :key="0" :disabled="true">
                      <span> <a-spin size="small" class="mr-2" /> Loading... </span>
                    </a-select-option>
                    <template v-else>
                      <a-select-option v-for="treatment in treatmentsArr" :key="treatment.id">
                        <span class="treatment-name">
                          {{ treatment.display_name }}
                        </span>
                      </a-select-option>
                    </template>
                  </a-select>
                </div>
              </div>
              <div class="row text-left mt-3 type-input">
                <p class="mb-0 col-12">
                  <label for="treatmentName" class="mb-1 input-label font-light"> Medication Dates </label>
                  <span class="required">*</span>
                </p>
                <div class="col-md-6 col-sm-12 m-mb16">
                  <!-- <a-date-picker
                    :allowClear="true"
                    class="d-inline-block w-100 pr-0 date-picker datePickerMob"
                    :size="'large'"
                    v-model="treatmentData.start_date"
                    :placeholder="treatmentData.treatment_type !== 'Procedure' ? 'From:' : 'Date'"
                    :disabled-date="tempValue => tempValue >= new Date()"
                    @change="handleStartDateChange"
                  >
                    <template v-if="treatmentData.start_date" #suffixIcon>
                      <font-awesome-icon
                        :icon="['far', 'times']"
                        class="gray400 cp show-in-mobile"
                        @click="
                          () => {
                            treatmentData.start_date = null
                          }
                        "
                      />
                    </template>
                  </a-date-picker> -->
                  <DatePicker
                    v-model="treatmentData.start_date"
                    :placeholder="treatmentData.treatment_type !== 'Procedure' ? 'From:' : 'Date'"
                    :disabled-date="tempValue => tempValue >= new Date() || tempValue < new Date(authUser.user.dob)"
                    type="date"
                    class="w-100 new-datepicker"
                    :clearable="false"
                    :append-to-body="false"
                  />
                </div>
                <div class="col-md-6 date-picker col-sm-12 type-input">
                  <!-- <a-date-picker
                    :allowClear="true"
                    class="d-inline-block w-100 pr-0 date-picker to-picker datePickerMob"
                    :size="'large'"
                    :disabled="treatmentData.currentlyInTreatment ? true : false || !treatmentData.start_date"
                    :disabled-date="disabledDate"
                    placeholder="To:"
                    v-model="treatmentData.end_date"
                    @change="handleEndDateChange"
                  >
                    <template v-if="treatmentData.end_date" #suffixIcon>
                      <font-awesome-icon
                        :icon="['far', 'times']"
                        class="gray400 cp show-in-mobile"
                        @click="
                          () => {
                            treatmentData.end_date = null
                          }
                        "
                      />
                    </template>
                  </a-date-picker> -->
                  <DatePicker
                    :disabled="treatmentData.currentlyInTreatment ? true : false || !treatmentData.start_date"
                    :disabled-date="disabledDate"
                    placeholder="To:"
                    v-model="treatmentData.end_date"
                    type="date"
                    class="w-100 new-datepicker"
                    :clearable="false"
                    :append-to-body="false"
                  />
                </div>
                <div class="col-md-6 col-sm-12 align-self-center currently-using">
                  <input type="checkbox" class="check-box" :checked="treatmentData.currentlyInTreatment" @change="toggleCurrentlyInTreatment" />
                  Currently Using
                </div>
                <div class="col-12 mt-3">
                  <label class="mb-1 input-label font-light"> Effectiveness </label>
                  <a-slider class="dovemed-slider mt-0" :marks="effectMarks" :step="50" :tooltipVisible="false" v-model="treatmentData.effectiveness" :disabled="treatmentData.dontKnow" />
                  <!-- @change="sliderColorChange('effect')" -->
                </div>

                <div class="col-md-6 col-sm-12 align-self-center currently-using d-k">
                  <input type="checkbox" class="check-box" :checked="treatmentData.dontKnow" @change="toggleDontKnow" />
                  I don’t know
                </div>

                <div class="col-12 mt-3">
                  <label class="mb-1 input-label font-light"> Affordability </label>
                  <a-slider class="dovemed-slider mt-0" :marks="affordMarks" :step="50" :tooltipVisible="false" v-model="treatmentData.affordability" />
                  <!-- @change="sliderColorChange('afford')" -->
                </div>
              </div>
              <div class="row mt-3 mb-5">
                <div class="col-12 text-left position-relative type-input s-e-c">
                  <label for="sideEffects" class="mb-1 input-label font-light"> Side Effects </label>
                  <font-awesome-icon size="1x" :icon="['fal', 'search']" class="position-absolute search-icon sr2 gray400" />
                  <a-select
                    mode="multiple"
                    :value="treatmentData.side_effects ? treatmentData.side_effects.map(ele => ele.display_name) : undefined"
                    :show-search="true"
                    :size="'large'"
                    placeholder="Search side effects"
                    allowClear
                    :filterOption="false"
                    class="w-100 selectMain sideEffectSelect onboarding-modal-selects"
                    notFoundContent=""
                    @search="searchSymptoms"
                    @change="handleSymptoms"
                    :disabled="!treatmentData.treatment"
                  >
                    <a-select-option v-for="(symptom, index) in symptomsList" :key="index" :value="symptom.display_name">
                      {{ symptom.display_name }}
                    </a-select-option>
                  </a-select>
                </div>

                <div class="col-12">
                  <div v-for="(symptom, index) in treatmentData.side_effects" :key="index">
                    <div class="symptoms-lists mt-3">
                      <div class="symp-name mob-one">
                        {{ symptom.display_name }}
                      </div>
                      <div class="symptom-radio mob-three">
                        <div class="symp-radiobtn">
                          <input type="radio" value="0" :checked="symptom.effectiveness === '0'" :name="symptom.display_name" @click="handleRadioChange" class="cp" />
                          <label class="symp-radiolabel">Mild</label>
                        </div>
                        <div class="symp-radiobtn moderate">
                          <input class="cp" type="radio" value="50" :checked="symptom.effectiveness === '50'" :name="symptom.display_name" @click="handleRadioChange" />
                          <label class="symp-radiolabel">Moderate</label>
                        </div>
                        <div class="symp-radiobtn">
                          <input class="cp" type="radio" value="100" :checked="symptom.effectiveness === '100'" :name="symptom.display_name" @click="handleRadioChange" />
                          <label class="symp-radiolabel">Severe</label>
                        </div>
                      </div>
                      <font-awesome-icon @click="deleteSideEffect(index)" size="2x" class="error300 delete-margin cp mob-two" :style="{ transform: 'scale(0.5)' }" :icon="['fas', 'trash']" />
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div class="d-flex flex-row-reverse footer pb-0">
              <a-button
                class="dovemed-button primary-button font-white rounded hide-in-mobile"
                :style="{
                  background: getPrimaryColor(),
                  opacity: !treatmentData.start_date || !treatmentData.treatment || (!treatmentData.end_date && !treatmentData.currentlyInTreatment) ? '0.3' : '1',
                }"
                @click="treatmentForm"
                :disabled="!treatmentData.start_date || !treatmentData.treatment || (!treatmentData.end_date && !treatmentData.currentlyInTreatment)"
              >
                {{ saving ? "Saving..." : "Save" }}
              </a-button>
            </div>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import DatePicker from "vue2-datepicker"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"

const AppRepository = RepositoryFactory.get("app")
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "AddMedicationModal",
  components: { DatePicker },
  data() {
    return {
      dummy: "",
      tabs: { search: true, add: false },
      currentDateChecked: false,
      circleTreatment: [],
      otherCircleTreatment: [],
      windowWidth: null,
      activeTab: "search",
      treatmentsArr: [],
      showModal: false,
      editTreatment: false,
      value: undefined,
      symptoms: [],
      symptomsList: [],
      treatmentData: {
        treatment: undefined,
        treatment_type: "others",
        activity_freq: null,
        start_date: null,
        end_date: null,
        currentlyInTreatment: null,
        dontKnow: null,
        effectiveness: 50,
        affordability: 50,
        side_effects: [],
      },
      treatmentInit: null,
      //   marks: {
      //     0: {
      //       style: {
      //         left: 0,
      //         marginLeft: 0,
      //         width: "unset",
      //         fontSize: "10px",
      //         top: "8px",
      //         transform: "none"
      //       },
      //       label: "NOT EFFECTIVE"
      //     },
      //     50: {
      //       style: {
      //         fontSize: "10px",
      //         top: "8px"
      //       },
      //       label: "SOMEWHAT EFFECTIVE"
      //     },
      //     100: {
      //       style: {
      //         right: 0,
      //         left: "unset",
      //         marginRight: 0,
      //         width: "unset",
      //         fontSize: "10px",
      //         top: "8px",
      //         transform: "none"
      //       },
      //       label: "VERY EFFECTIVE"
      //     }
      //   }
      effectMarks: {
        0: {
          style: {
            left: 0,
            marginLeft: 0,
            // width: "unset",
            fontSize: "10px",
            top: "8px",
            transform: "none",
          },
          label: "NOT EFFECTIVE",
        },
        50: {
          style: {
            fontSize: "10px",
            top: "8px",
          },
          label: "SOMEWHAT EFFECTIVE",
        },
        100: {
          style: {
            right: 0,
            left: "unset",
            marginRight: 0,
            // width: "unset",
            fontSize: "10px",
            top: "8px",
            transform: "none",
          },
          label: "VERY EFFECTIVE",
        },
      },
      affordMarks: {
        0: {
          style: {
            left: 0,
            marginLeft: 0,
            // width: "unset",
            fontSize: "10px",
            top: "8px",
            transform: "none",
          },
          label: "NOT AFFORDABLE",
        },
        50: {
          style: {
            fontSize: "10px",
            top: "8px",
          },
          label: "SOMEWHAT AFFORDABLE",
        },
        100: {
          style: {
            right: 0,
            left: "unset",
            marginRight: 0,
            // width: "unset",
            fontSize: "10px",
            top: "8px",
            transform: "none",
          },
          label: "VERY AFFORDABLE",
        },
      },
      loadingMed: false,
      saving: false,
    }
  },
  created() {
    console.log("authUser.user", this.authUser.user)
    this.searchSymptoms("a")
    this.init()
    this.handleTreatmentSearch()
    this.windowWidth = window.innerWidth
  },
  watch: {
    "treatmentData.treatment_type": function() {
      this.handleTreatmentSearch()
    },
  },
  computed: {
    ...mapGetters({ user: "User/user" }),
  },
  filters: {
    humanize: function(value, capitalize = true) {
      if (!value) return ""
      return capitalize
        ? value
            .toLowerCase()
            .split("_")
            .map(e => e.toUpperCase())
            .join(" ")
        : value
            .toLowerCase()
            .split("_")
            .map(e => e.charAt(0).toUpperCase() + e.substring(1))
            .join(" ")
    },
  },
  methods: {
    deleteSideEffect(ind) {
      this.treatmentData.side_effects = this.treatmentData.side_effects.filter((effect, index) => ind !== index)
    },
    init() {
      UserRepository.getSymptoms(this.authUser.user, this.currentCircle.id)
        .then(res => {
          if (res.data) {
            const circleSymptoms = res.data.data.circle_symptoms
            const otherSymptoms = res.data.data.other_symptoms
            // const savedSymptoms = res.data.data
            circleSymptoms.map(s => {
              this.symptoms.push(s.id)
            })
            otherSymptoms.map(s => {
              this.otherSymptoms.push(s.id)
            })
          }
          this.load = true
        })
        .catch(err => null)
    },
    handleRadioChange(e) {
      this.treatmentData.side_effects.map(smpt => {
        if (e.target.name === smpt.display_name) {
          return (smpt.effectiveness = e.target.value)
        }
      })
    },
    searchSymptoms(value) {
      AppRepository.searchSymptoms(value, this.currentCircle).then(res => {
        if (res.data.data.circle_sideeffects) {
          this.symptomsList = [...res.data.data.circle_sideeffects]
        } else {
          this.symptomsList = []
        }
        // this.otherSymptomsList = [
        //   ...res.data.data.other_symptoms,
        //   ...res.data.data.other_sideeffects
        // ];
      })
    },
    handleSymptoms(value) {
      this.treatmentData.side_effects = value.map(smtp => {
        const oldSymptom = this.treatmentData.side_effects.find(symt => {
          return symt.display_name === smtp
        })
        return {
          display_name: smtp,
          effectiveness: oldSymptom ? oldSymptom.effectiveness : "50",
        }
      })
      this.symptomsList = []
      // this.changeColor(value, "c-select_a");
      // this.treatmentData.side_effects = [
      //   { display_name: value, effectiveness: "50" }
      // ];
    },
    /**
     * Change tab based on user selection
     *
     * @param {Object} event
     */
    changeTab(event) {
      if (this.tabs.hasOwnProperty(event.target.id)) {
        this.tabs[this.activeTab] = false
        this.tabs[event.target.id] = true
        this.activeTab = event.target.id
      }
    },
    /**
     * Handle Activity frequency change
     * @param Object event
     */
    handleActivityFrequencyChange(event) {
      this.treatmentData.activity_freq = event.target.value
    },
    /**
     * Handle Type Change
     * @param String value
     */
    handleTypeChange(value) {
      this.treatmentData.treatment_type = value
      this.treatmentData.treatment = null
    },
    /**
     * Handle Treatment search
     * @param String value
     */
    handleTreatmentSearch(value = "a") {
      this.loadingMed = true
      AppRepository.searchTreatments(value, this.currentCircle.id, this.treatmentData.treatment_type, 1)
        .then(res => {
          this.treatmentsArr = []
          if (res.data.data.circle_treatments) {
            if (this.treatmentData.treatment_type === "others") {
              if (res.data.data.extra_treatments) {
                this.treatmentsArr = res.data.data.extra_treatments.map(ele => {
                  ele.display_name = ele.display_name
                  // ele.display_name = ele.display_name.toLowerCase()
                  return ele
                })
              }
            } else {
              this.treatmentsArr =
                this.activeTab === "search"
                  ? res.data.data.circle_treatments.map(ele => {
                      ele.display_name = ele.display_name
                      // ele.display_name = ele.display_name.toLowerCase()
                      return ele
                    })
                  : res.data.data.other_treatments.map(ele => {
                      ele.display_name = ele.display_name
                      // ele.display_name = ele.display_name.toLowerCase()
                      return ele
                    })
            }
          }
          this.loadingMed = false
        })
        .catch(e => {
          this.loadingMed = false
        })
    },
    handleTreatmentChange(value) {
      this.value = value
      this.treatmentData.treatment = value
    },
    show(data, init) {
      console.warn("AddMedication.vue is shown")

      this.showModal = true
      this.treatmentInit = init
      if (data !== "") {
        this.editTreatment = true
        this.treatmentData = data
      } else {
        // this.editTreatment = false;
        // this.treatmentData = {
        //   treatment: null,
        //   treatment_type: "Medication",
        //   start_date: null,
        //   end_date: null,
        //   currentlyInTreatment: null,
        //   effectiveness: 0,
        //   side_effects: [],
        //   activity_freq: null
        // };
      }
    },
    hide() {
      this.saving = false
      this.treatmentData = {
        treatment: undefined,
        treatment_type: "others",
        start_date: null,
        end_date: null,
        currentlyInTreatment: null,
        dontKnow: null,
        effectiveness: 50,
        affordability: 50,
        side_effects: [],
        activity_freq: null,
      }
      // document.querySelector(".ant-slider-track").setAttribute("style", "background-color: #2A71D4; width:50%")
      // document.querySelector(".ant-slider-handle").setAttribute("style", "background-color: #2A71D4")
      // Object.assign(this.$data.treatmentData, this.treatmentData)
      this.showModal = false
    },
    treatmentForm() {
      if (this.saving) {
        return
      }
      this.saving = true
      const treatKey = this.activeTab === "search" ? { treatment: this.treatmentData.treatment } : { other_treatment: this.treatmentData.treatment }
      const payload = {
        // treatment: this.treatmentData.treatment,
        ...treatKey,
        treatment_type: this.treatmentData.treatment_type === "others" ? "Medication" : this.treatmentData.treatment_type,
        activity_freq: this.treatmentData.activity_freq,
        user_circle: this.currentCircle.id,
        user: this.authUser.user.id,
        treatment_duration: [
          [
            this.moment(this.treatmentData.start_date).format("YYYY-MM-DD"),
            // this.treatmentData.end_date ? this.moment(this.treatmentData.end_date).format("YYYY-MM-DD") : this.moment().format("YYYY-MM-DD"),
            !this.treatmentData.currentlyInTreatment ? this.moment(this.treatmentData.end_date).format("YYYY-MM-DD") : null,
          ],
        ],
        start_date: this.moment(this.treatmentData.start_date).format("YYYY-MM-DD"),
        end_date: this.treatmentData.end_date ? this.moment(this.treatmentData.end_date).format("YYYY-MM-DD") : this.moment().format("YYYY-MM-DD"),
        effectiveness: this.treatmentData.effectiveness,
        affordability: this.treatmentData.affordability,
        side_effect: this.treatmentData.side_effects || [],
      }
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      }
      const url = `${process.env.BASE_API_URL}/treatment/`
      if (payload.start_date) {
        if (this.editTreatment) {
          const urlWithParams = `${url}${this.treatmentData.id}`
          this.$store
            .dispatch("Signup/updateTreatment", {
              url: urlWithParams,
              payload,
              headers,
            })
            .then(() => {
              this.$emit("refresh")
              // this.$notification.success({
              //   message: "Success",
              //   description: "Treatment Submitted successfully."
              // });
              window.location.reload()
            })
          this.hide()
        } else {
          this.$store
            .dispatch("Signup/setTreatment", { url, payload, headers })
            .then(() => {
              // window.location.reload();
              // this.$emit("refresh");
              // this.$notification.success({
              //   message: "Success",
              //   description: "Treatment Submitted successfully."
              // });
              this.hide()
              this.treatmentInit()
            })
            .catch(e => {
              this.saving = false
            })
        }
        this.editTreatment = false
        // this.treatmentData = {
        //   treatment: null,
        //   treatment_type: "Medication",
        //   start_date: null,
        //   end_date: null,
        //   currentlyInTreatment: null,
        //   dontKnow: null,
        //   effectiveness: 0,
        //   affordability: 0,
        //   side_effects: [],
        //   activity_freq: null,
        // }
      } else {
        this.$notification.error({
          message: "Error",
          description: "Empty Data Check The Fields",
        })
      }
    },
    handleStartDateChange(date, dateString) {
      this.treatmentData.start_date = dateString
      this.treatmentData.end_date = null
    },
    handleEndDateChange(date, dateString) {
      this.treatmentData.end_date = dateString
    },
    disabledDate(current) {
      return current > new Date() || (current && current < this.moment(this.treatmentData.start_date))
    },
    toggleCurrentlyInTreatment(e) {
      this.treatmentData.currentlyInTreatment = e.target.checked
      this.treatmentData.end_date = this.moment().format("YYYY-MM-DD")
    },
    toggleDontKnow(e) {
      this.treatmentData.dontKnow = e.target.checked
    },
    sliderColorChange(event, current) {
      // console.log(current);

      // console.log(
      //   this.treatmentData.affordability,
      //   this.treatmentData.effectiveness
      // );

      if (current === "effect") {
        if (event === 0) {
          document.querySelector(".ant-slider-track").setAttribute("style", "background-color: red !important;width:50%")
          document.querySelector(".ant-slider-handle").setAttribute("style", "background-color: red !important")
        } else if (event === 100) {
          document.querySelector(".ant-slider-track").setAttribute("style", "background-color: green !important;width:100%")
          document.querySelector(".ant-slider-handle").setAttribute("style", "background-color: green !important")
        } else {
          document.querySelector(".ant-slider-track").setAttribute("style", "background-color: #2A71D4 !important;width:50%")
          document.querySelector(".ant-slider-handle").setAttribute("style", "background-color: #2A71D4 !important")
        }
      } else if (current === "afford") {
        if (event === 0) {
          document.querySelectorAll(".ant-slider-track")[1].setAttribute("style", "background-color: red !important;width:50%")
          document.querySelectorAll(".ant-slider-handle")[1].setAttribute("style", "background-color: red !important")
        } else if (event === 100) {
          document.querySelectorAll(".ant-slider-track")[1].setAttribute("style", "background-color: green !important;width:100%")
          document.querySelectorAll(".ant-slider-handle")[1].setAttribute("style", "background-color: green !important")
        } else {
          document.querySelectorAll(".ant-slider-track")[1].setAttribute("style", "background-color: #2A71D4 !important;width:50%")
          document.querySelectorAll(".ant-slider-handle")[1].setAttribute("style", "background-color: #2A71D4 !important")
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dovemed-button {
  padding: 12px 24px;
  // cursor: pointer;
}
.footer {
  // border-top: unser;
  margin-right: -22px;
  margin-left: -22px;
  padding: 0 22px;
}
.check-box {
  transform: scale(1.1);
  margin-right: 5px;
  cursor: pointer;
}
.flex-row {
  display: flex;
}
.radio-group-wrapper {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  label {
    padding: 5px;
  }
}
.currently-using {
  padding: 10px;
  margin-left: 5px;
}
.required {
  color: tomato !important;
}
.symptoms-lists {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  border-radius: 5px;
  @media screen and (max-width: 900px) {
    padding: 12px;
    // flex-direction: column;
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 767px) {
  .treatment-modal .ant-modal-centered .ant-modal {
    width: 100vw !important;
    margin: 0 !important;
    height: 100vh;
  }
  .input-type {
    font-size: 12px;
    padding: 0px;
  }
  .input-treatment-name {
    width: 80%;
  }
  .date-picker {
    width: 100%;
  }
  .currently-using {
    display: inline;
    margin-top: 16px;
  }
  .s-e-c,
  .d-k {
    margin-top: 16px;
  }
}
@media (max-width: 767px) {
  .ant-modal-centered .ant-modal {
    flex: 1;
    width: 100vw !important;
    margin: 0;
    height: 100vh;
  }
}
.symptom-radio {
  width: 50%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .symp-radiobtn {
    display: flex;
    align-items: center;
  }
  .symp-radiolabel {
    margin-bottom: unset !important;
    margin-left: 8px;
  }
  .moderate {
    // margin: 0 24px;
  }
  @media screen and (max-width: 900px) {
    margin-top: 10px;
    width: 100%;
  }
}
.to-picker {
  @media screen and (max-width: 900px) {
    margin-top: 10px;
  }
}
.procedure-types {
  &::after {
    content: ",";
  }
  &:last-child::after {
    content: "";
  }
}
.treatment-name {
  text-transform: capitalize;
  // margin-left: 30px;
}
.dovemed-slider {
  .ant-slider-handle {
    background-color: #2a71d4 !important ;
  }
  .ant-slider-track {
    background-color: #2a71d4 !important ;
  }
}
.input-label {
  font-weight: 700;
  font-size: 16px;
  color: #647490;
}
.search-icon {
  margin-left: 5px;
  left: 20px;
  z-index: 1;
  // top: 35px;
  top: 47px;
  font-size: 20px;
  color: #647490;
}
.sr2 {
  top: 50%;
  transform: translateY(10%);
}
.symp-name {
  text-align: start;
  width: 136px;
  font-size: 16px;
  margin-right: 48px;
  @media screen and (max-width: 900px) {
    margin-right: 0;
    width: auto;
  }
}
.delete-margin {
  margin-left: 50px;
  @media screen and (max-width: 900px) {
    margin-left: 0;
  }
}
@media screen and (max-width: 600px) {
  .mob-one {
    order: 1;
  }
  .mob-two {
    order: 2;
    margin-left: auto;
  }
  .mob-three {
    margin-top: 24px;
    order: 3;
    gap: 24px;
    justify-content: flex-start !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/AddMedication.vue